import { useCallback, useState } from 'react';

export function useProfessionalAvailabiltiy() {
	const [professionalNotAvailableModal, setProfessionalNotAvailableModal] = useState(false);
	const [professionalAvailableModal, setProfessionalAvailableModal] = useState(false);

	const toggleProfessionalNotAvailableModal = useCallback((value?: boolean) => {
		setProfessionalNotAvailableModal(value ?? !professionalNotAvailableModal);
	}, [professionalNotAvailableModal]);

	const toggleProfessionalAvailableModal = useCallback((value?: boolean) => {
		setProfessionalAvailableModal(value ?? !professionalAvailableModal);
	}, [professionalAvailableModal]);

	return {
		professionalNotAvailableModal,
		professionalAvailableModal,
		toggleProfessionalNotAvailableModal,
		toggleProfessionalAvailableModal
	};
}